/* eslint-disable no-undef */
import React, { useEffect, useState, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { valueToOption, optionToValue } from 'helpers/objectHelpers';
import LocaleContext from 'constants/localization';
import API from 'constants/api';

import Select from 'react-select';
import Header from 'field/common/Header';

// SPEC-41
// Select parent collection from list
// use parent to retrieve child collections as a list
const AcquisitionCollectionEdit = ({ field }) => {
  const LS = useContext(LocaleContext);
  const uri = useSelector(state => state.object.uri);

  const [selectedParent, setSelectedParent] = useState({});
  const [parentOptions, setParentOptions] = useState([]);
  const [subCollectionOptions, setSubCollectionOptions] = useState([]);

  useEffect(() => {
    loadParentCollectionOptions(uri)
      .then(res => {
        setParentOptions(res.options);
        if (res.parent) {
          setSelectedParent(res.parent);
        // No parent returned, set value as indenpendent parent collection SPEC-354
        } else if (field.values.length > 0) {
          const value = field.values[0];
          setSelectedParent({
            ...value,
            label: value.display,
            value: value.uri,
            isIndependent: true
          });
        }
      });
  }, []);

  useEffect(() => {
    const parentUri = selectedParent.value;
    if (selectedParent.isIndependent) {
      setSubCollectionOptions([]);
      field.setValue(0, selectedParent);
    }
    else if (parentUri) {
      loadSubCollectionOptions(parentUri)
        .then(options => setSubCollectionOptions(options));
    }
  }, [selectedParent]);

  const ParentSelect = () => (
    <div style={{ marginBottom: '0.5rem' }}>
      <Header field={{label: LS.parentCollection}} />
      <Select 
        options={parentOptions}
        value={selectedParent}
        onChange={value => {
          if (!value.isIndependent) {
            field.removeValue(0);
          }
          setSelectedParent(value);
        }}
      />
    </div>
  );

  const SubSelect = () => {
    if (selectedParent.value === undefined || selectedParent.isIndependent) {
      return null;
    }
    return (
      <div>
        <Header field={{label: LS.subCollection}} />
        <Select
          options={subCollectionOptions}
          value={valueToOption(field.values[0])}
          onChange={option => field.setValue(0, optionToValue(option))}
        />
      </div>
    );
  }  

  return (
    <div className="field">
      <ParentSelect />
      <SubSelect />
    </div>
  );
};

/**
 * Load options for acquisition parent collections
 */
const loadParentCollectionOptions = (objectUri) => {
  return fetch(`${API.ACQUISITION}/parentCollections?uri=${objectUri}`)
    .then(res => res.json()
      .then(res => {
        let { values, parent } = res;
        const options = values.map(value => {
          return {
            ...value,
            value: value.uri,
            label: value.display,
          };
        });
        if (parent) {
          parent = options.find(option => option.value === parent);
        }
        return {
          options,
          parent 
        };
      }));
};

/**
 * Load subcollections for parent collection
 */
const loadSubCollectionOptions = (parent) => {
  return fetch(`${API.ACQUISITION}/subCollection?parent=${parent}`)
    .then(res => res.json())
    .then(values => values.map(valueToOption));
};

export default AcquisitionCollectionEdit;